// The native apps keep a WebView alive for days, so a resumed app reloads once a newer web build is live.
const MAIN_SCRIPT = /\/static\/js\/main\.[0-9a-f]+\.js/;
export const MIN_HIDDEN_MS = 5 * 60 * 1000;

export function buildIn(html) {
    const match = MAIN_SCRIPT.exec(html || '');
    return match ? match[0] : null;
}

export function loadedBuild(doc = document) {
    return Array.from(doc.scripts).map(s => buildIn(s.src)).find(Boolean) || null;
}

async function liveBuild() {
    const res = await fetch('/app.html', { cache: 'no-store' });
    return res.ok ? buildIn(await res.text()) : null;
}

// Short trips (the share sheet, a quick app switch) never reload.
export function reloadOnNewBuild({ reload = () => window.location.reload(), now = Date.now } = {}) {
    const loaded = loadedBuild();
    if (!loaded) return () => {};
    let hiddenAt = null;
    const onVisibility = async () => {
        if (document.visibilityState === 'hidden') {
            if (hiddenAt === null) hiddenAt = now();
            return;
        }
        const away = hiddenAt === null ? 0 : now() - hiddenAt;
        hiddenAt = null;
        if (away < MIN_HIDDEN_MS) return;
        try {
            const live = await liveBuild();
            if (live && live !== loaded) reload();
        } catch {
            // offline: keep the running build
        }
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
}
